import { trimEnd } from 'lodash'

const HTTP_PROTOCOLS: string[] = ['https://', 'http://']

const DISPLAY_IGNORED_PREFIXES: string[] = [...HTTP_PROTOCOLS, 'www.']

const startsWithIgnoringCase = (value: string, prefix: string): boolean =>
  value.toLowerCase().startsWith(prefix)

export const hasHttpProtocol = (url: string): boolean =>
  HTTP_PROTOCOLS.some((protocol: string): boolean => startsWithIgnoringCase(url, protocol))

/**
 * @example
 * displayUrl('https://www.onet.pl/') // 'onet.pl'
 * displayUrl('HTTPS://onet.pl/Sport/') // 'onet.pl/Sport'
 * displayUrl('http://onet.pl/sport?page=2') // 'onet.pl/sport?page=2'
 */
export const displayUrl = (url: string): string => {
  let rest: string = url

  for (const prefix of DISPLAY_IGNORED_PREFIXES) {
    if (startsWithIgnoringCase(rest, prefix)) {
      rest = rest.slice(prefix.length)
    }
  }

  return trimEnd(rest, '/')
}
